module.exports = __webpack_public_path__ + "media/bootstrap-icons/mortarboard-c0d9075c.svg";